import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AddNewBrickDialogState } from './brick-menu/add-new-brick-dialog.state';
import { BrickWallState } from './brick-wall/brick-wall.state';
import { BrickGainedFocus, BrickLostFocus } from './dashboard.actions';
import { PilotPanelState } from './pilot-panel/pilot-panel.state';

export interface DashboardStateModel {
   focusedBrickInstanceId: string;
}

@State<DashboardStateModel>({
   name: 'dashboard',
   defaults: {
      focusedBrickInstanceId: null,
   },
   children: [PilotPanelState, BrickWallState, AddNewBrickDialogState],
})
@Injectable()
export class DashboardState {
   @Selector([DashboardState])
   public static isBrickFocussedFn(state): (brickInstanceId: string) => boolean {
      return (brickInstanceId: string) => {
         return state.focusedBrickInstanceId === brickInstanceId;
      };
   }

   @Action(BrickGainedFocus)
   public brickGainedFocus(ctx: StateContext<DashboardStateModel>, action: BrickGainedFocus) {
      ctx.patchState({
         focusedBrickInstanceId: action.brickInstanceId,
      });
   }

   @Action(BrickLostFocus)
   public brickLostFocus(ctx: StateContext<DashboardStateModel>, action: BrickLostFocus) {
      if (ctx.getState().focusedBrickInstanceId !== action.brickInstanceId) {
         return;
      }

      ctx.patchState({
         focusedBrickInstanceId: null,
      });
   }
}
